import { Component, OnInit, Input, EventEmitter, Output, inject, OnChanges, SimpleChanges, } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardWrapperComponent } from '../../../shared/components/card-wrapper/card-wrapper.component';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';
import { I18nPipe } from '../../../shared/pipes/i18n.pipe';
import { I18nService } from '../../../core/services/i18n.service';

@Component({
  selector: 'umkt-payment-method-card',
  standalone: true,
  imports: [
    CommonModule,
    CardWrapperComponent,
    LoadingComponent,
    I18nPipe
  ],
  templateUrl: './payment-method-card.component.html',
  styleUrl: './payment-method-card.component.scss',
})
export class PaymentMethodCardComponent implements OnInit, OnChanges {
  isLoading: boolean = false;

  private i18nService = inject(I18nService);

  @Input() isPlanPayment: boolean = false;
  @Input() canGoToPreviousStep = false;
  @Input() canGoToNextStep = false;
  @Input() initiallyOpen = true;
  @Input() disabled = false;
  @Input() isEditing = true;
  @Input() isLastStep = false;
  @Input() invoicePaymentType: 'minha_conta' | 'boleto_cartao' = 'boleto_cartao';
  @Input() showInvoiceUnavailableWarning = false;
  @Input() invoiceUnavailableProducts: string[] = [];
  @Input() disableInvoiceOption = false;
  @Output() invoicePaymentTypeChange = new EventEmitter<'minha_conta' | 'boleto_cartao'>();
  @Output() previousStep = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() editingStateChange = new EventEmitter<boolean>();

  private originalInvoicePaymentType: 'minha_conta' | 'boleto_cartao' | null = null;

  get isInvoiceUnavailableSelectionBlocked(): boolean {
    return this.disableInvoiceOption && this.invoicePaymentType === 'minha_conta';
  }

  ngOnInit(): void {
    this.editingStateChange.emit(this.isEditing);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['invoicePaymentType'] && !changes['invoicePaymentType'].firstChange) {
      this.invoicePaymentType = changes['invoicePaymentType'].currentValue;
    }
  }

  onInvoicePaymentTypeChange(type: 'minha_conta' | 'boleto_cartao'): void {
    if (type === 'minha_conta' && this.disableInvoiceOption) {
      return;
    }

    this.invoicePaymentType = type;
    this.invoicePaymentTypeChange.emit(type);
  }

  editPayment(): void {
    if (this.isLastStep) {
      this.originalInvoicePaymentType = this.invoicePaymentType;
    }
    this.isEditing = true;
    this.editingStateChange.emit(true);
  }

  cancelEdit(): void {
    if (this.isLastStep && this.originalInvoicePaymentType !== null) {
      this.invoicePaymentType = this.originalInvoicePaymentType;
      this.invoicePaymentTypeChange.emit(this.originalInvoicePaymentType);
      this.originalInvoicePaymentType = null;
    }
    this.isEditing = false;
    this.editingStateChange.emit(false);
  }

  saveAndContinue(): void {
    if (this.isInvoiceUnavailableSelectionBlocked) {
      return;
    }

    if (this.isLastStep) {
      this.originalInvoicePaymentType = null;
    }

    this.isEditing = false;
    this.editingStateChange.emit(false);
    if (!this.isLastStep) {
      this.nextStep.emit();
    }
  }

  getSelectedPaymentMethodLabel(): string {
    if (this.invoicePaymentType === 'minha_conta') {
      return this.i18nService.instant('pages.paymentMethod.options.invoice');
    }

    return this.i18nService.instant('pages.paymentMethod.options.boletoCredit');
  }

}
